<template>
  <div class="d-flex-row justify-start">
    <div class="seller_avatar_container">
      <img
        :src="`${publicConfig.apiBaseUrl}${avatar}`"
        alt="seller avatart"
        height="42"
        width="42"
        style="border-radius: 42px"
      />
      <div v-if="online === 1" class="online-indicator-online"></div>
      <svg
        v-else
        class="online-indicator"
        width="12"
        height="12"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="1.5" y="1.5" width="12" height="12" rx="6" fill="#fc485a" />
        <rect
          x="1.5"
          y="1.5"
          width="12"
          height="12"
          rx="6"
          stroke="#0E1012"
          stroke-width="3"
        />
      </svg>
    </div>
    <div class="d-flex-column justify-start align-start" style="gap: 3px">
      <label class="bold-l font-family-2 t-white">{{ username }}</label>
      <div class="d-flex-row justify-start gap-5">
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.40639 1.13331C5.78115 0.955565 6.21593 0.955565 6.59069 1.13331C6.85848 1.26031 7.04188 1.49752 7.19551 1.74553C7.35021 1.99527 7.51901 2.33288 7.72543 2.74573L7.73555 2.76598L7.90328 3.10144C8.04876 3.3924 8.08329 3.45096 8.12278 3.49229C8.16749 3.53909 8.22111 3.57647 8.28048 3.60225C8.33291 3.62501 8.3998 3.63717 8.72312 3.6731L8.87538 3.69002L8.89812 3.69254C9.39425 3.74766 9.79733 3.79244 10.1041 3.85483C10.4055 3.91614 10.7088 4.01042 10.9252 4.2312C11.2248 4.53687 11.3658 4.96411 11.3071 5.38807C11.2647 5.6943 11.0771 5.95065 10.8715 6.17935C10.6621 6.4121 10.3649 6.68806 9.99915 7.02772L9.98238 7.04329L9.82163 7.19256C9.53686 7.45699 9.48154 7.51715 9.45119 7.57624C9.41674 7.64333 9.39838 7.71753 9.39759 7.79295C9.3969 7.85922 9.41833 7.93994 9.54876 8.31165L9.55634 8.33325C9.74375 8.86737 9.89437 9.29663 9.98029 9.63215C10.0631 9.95554 10.1175 10.2989 9.99773 10.604C9.83496 11.0186 9.48233 11.3293 9.05056 11.4386C8.73379 11.5188 8.40296 11.4236 8.095 11.3021C7.77661 11.1765 7.37537 10.9759 6.87706 10.7267L6.85644 10.7164L6.4662 10.5213C6.198 10.3872 6.14038 10.3629 6.08807 10.3531C6.0289 10.342 5.96818 10.342 5.90902 10.3531C5.8567 10.3629 5.79908 10.3872 5.53089 10.5213L5.14064 10.7164L5.12007 10.7267C4.62173 10.9759 4.22048 11.1765 3.90208 11.3021C3.59412 11.4236 3.26329 11.5188 2.94652 11.4386C2.51475 11.3293 2.16212 11.0186 1.99935 10.604C1.87956 10.2989 1.93398 9.95554 2.01679 9.63215C2.10271 9.29662 2.25334 8.86733 2.44077 8.33319L2.44832 8.31165C2.57875 7.93994 2.60019 7.85922 2.59949 7.79295C2.5987 7.71753 2.58034 7.64333 2.54589 7.57624C2.51554 7.51715 2.46022 7.45699 2.17545 7.19256L2.0147 7.04329L1.99793 7.02772C1.63213 6.68806 1.33494 6.4121 1.12563 6.17935C0.919974 5.95065 0.732383 5.6943 0.689963 5.38807C0.631233 4.96411 0.772277 4.53687 1.07188 4.2312C1.28827 4.01042 1.59162 3.91614 1.89301 3.85483C2.19975 3.79244 2.60283 3.74766 3.09895 3.69254L3.1217 3.69002L3.27397 3.6731C3.59728 3.63717 3.66417 3.62501 3.7166 3.60225C3.77597 3.57647 3.82959 3.53909 3.8743 3.49229C3.91379 3.45096 3.94832 3.3924 4.0938 3.10144L4.26153 2.76598L4.27167 2.74571C4.47808 2.33287 4.64688 1.99526 4.80158 1.74552C4.9552 1.49752 5.13861 1.26031 5.40639 1.13331ZM6.20659 1.94316C6.07492 1.88071 5.92216 1.88071 5.79049 1.94316C5.7673 1.95416 5.6977 2.00098 5.56355 2.21753C5.433 2.42828 5.28225 2.72878 5.06323 3.16683L4.8955 3.50229C4.88795 3.51739 4.88048 3.53236 4.87308 3.5472C4.76283 3.76832 4.66742 3.95966 4.52238 4.11147C4.39513 4.24467 4.24253 4.35107 4.07356 4.42443C3.88097 4.50805 3.66844 4.53142 3.42284 4.55844C3.40636 4.56025 3.38973 4.56208 3.37295 4.56394L3.22068 4.58086C2.69637 4.63912 2.33392 4.67983 2.07167 4.73318C1.79938 4.78856 1.72854 4.84174 1.712 4.85862C1.60673 4.96601 1.55718 5.11612 1.57781 5.26508C1.58105 5.28849 1.60631 5.3734 1.79211 5.58C1.97106 5.779 2.23803 6.0275 2.62461 6.38647L2.78536 6.53574C2.80027 6.54958 2.81505 6.56327 2.8297 6.57684C3.04513 6.77637 3.23123 6.94872 3.34321 7.16675C3.44128 7.3577 3.49351 7.56888 3.49577 7.78353C3.49834 8.02865 3.41326 8.27012 3.31455 8.55028C3.30779 8.56947 3.30096 8.58885 3.2941 8.60841C3.09737 9.16908 2.96016 9.56138 2.8851 9.8545C2.80578 10.1643 2.82669 10.2586 2.83368 10.2764C2.89087 10.4221 3.01477 10.5313 3.16647 10.5697C3.18604 10.5746 3.28128 10.5834 3.5732 10.4683C3.85031 10.359 4.21609 10.1766 4.73979 9.91473L5.13004 9.71961C5.14391 9.71267 5.15766 9.70578 5.17128 9.69895C5.37528 9.59669 5.55191 9.50815 5.74374 9.47216C5.91214 9.44056 6.08495 9.44056 6.25335 9.47216C6.44517 9.50815 6.62181 9.59669 6.82582 9.69896C6.83943 9.70579 6.85317 9.71267 6.86705 9.71961L7.25729 9.91473C7.78099 10.1766 8.14677 10.359 8.42388 10.4683C8.7158 10.5834 8.81104 10.5746 8.83061 10.5697C8.98231 10.5313 9.10621 10.4221 9.1634 10.2764C9.17039 10.2586 9.1913 10.1643 9.11198 9.8545C9.03692 9.56138 8.89971 9.16908 8.70298 8.60841C8.69612 8.58884 8.68929 8.56947 8.68253 8.55027C8.58382 8.27012 8.49874 8.02865 8.50131 7.78353C8.50357 7.56888 8.5558 7.3577 8.65387 7.16675C8.76585 6.94872 8.95194 6.77637 9.16737 6.57685C9.18203 6.56328 9.19681 6.54958 9.21172 6.53574L9.37247 6.38647C9.75905 6.0275 10.026 5.779 10.205 5.58C10.3908 5.3734 10.416 5.28849 10.4193 5.26508C10.4399 5.11612 10.3903 4.96601 10.2851 4.85862C10.2685 4.84174 10.1977 4.78856 9.92542 4.73318C9.66316 4.67983 9.30071 4.63912 8.7764 4.58086L8.62413 4.56394C8.60735 4.56208 8.59072 4.56025 8.57424 4.55844C8.32864 4.53142 8.11611 4.50805 7.92352 4.42443C7.75455 4.35107 7.60195 4.24466 7.4747 4.11147C7.32965 3.95966 7.23425 3.76832 7.12399 3.54719C7.1166 3.53236 7.10913 3.51739 7.10158 3.50228L6.93386 3.16683C6.71483 2.72879 6.56408 2.42828 6.43353 2.21754C6.29939 2.00098 6.22979 1.95416 6.20659 1.94316Z"
            fill="#9A9A9A"
          />
        </svg>
        <label class="regular-s font-family-2 t-grey"
          >{{ reviewPercentage }}%</label
        >
        <label class="regular-s font-family-2 t-grey"
          >({{ totalReviews }})</label
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    avatar: {
      type: String,
      default: "",
    },
    online: {
      default: 0,
    },
    username: {
      default: "",
    },

    totalReviews: {
      default: 0,
    },
    reviewPercentage: {
      default: 0,
    },
  },
  setup() {
    const { public: publicConfig } = useRuntimeConfig();
    return {
      publicConfig,
    };
  },
};
</script>
